// extracted by mini-css-extract-plugin
module.exports = {"brandLogo":"BrandLogo_brandLogo__1PpGj","brandLogoFixed":"BrandLogo_brandLogoFixed__2SyHS"};